/**
 * Normaliza errores de API a mensajes amigables en espanol.
 */
export function getErrorMessage(error) {
  if (!error) {
    return 'Ha ocurrido un error inesperado.';
  }

  // Sin conexion a internet
  if (!error.response) {
    return 'No se pudo conectar con el servidor. Verifique su conexion a internet e intente de nuevo.';
  }

  const { status, data } = error.response;

  switch (status) {
    case 401:
      return 'Su sesion ha expirado. Por favor inicie sesion nuevamente.';
    case 403:
      return 'No tiene permisos para realizar esta accion.';
    case 404:
      return 'El recurso solicitado no fue encontrado.';
    case 422:
      // Validation errors from Laravel
      if (data?.errors) {
        const messages = Object.values(data.errors).flat();
        return messages.join(' ');
      }
      if (data?.message) {
        return data.message;
      }
      return 'Los datos enviados no son validos. Por favor revise e intente de nuevo.';
    case 429:
      return 'Demasiadas solicitudes. Por favor espere un momento e intente de nuevo.';
    case 500:
    default:
      return 'Ha ocurrido un error en el servidor. Por favor intente mas tarde.';
  }
}
